/** Which entity an activity event belongs to.
 *
 *  `entity_type` + `entity_id` is the typed reference every read path groups,
 *  filters and visibility-checks on, beside the original `issue_id`. The list
 *  holds one member today; it is the extension point for an event model that
 *  carries more than one kind of entity rather than splitting into unrelated
 *  tables.
 *
 *  Server and client both read this list. It lives here so the two cannot
 *  drift, exactly like NO_OUTCOME_KEY. */
export const ACTIVITY_ENTITY_TYPES = ["project"] as const;

export type ActivityEntityType = (typeof ACTIVITY_ENTITY_TYPES)[number];

/** The type every writer stamps. */
export const DEFAULT_ACTIVITY_ENTITY_TYPE: ActivityEntityType = "project";
